import axios from 'axios'

const getKaxaaIndexPrice = () => {
  try {
    return axios
      // https://indexapi.kaxaa.com
      .get('https://index-api.kaxaa.com/')
      .then((result: any) => {
        // eslint-disable-next-line camelcase
        console.log(result, "Index price REsult");
        const { value } = result.data
        // // eslint-disable-next-line camelcase
        if (!value) {
          return 0.3731
        }
        return value
      })
      .catch((error) => {
        console.error('kaxaa: index price err:', error)

        return 0.3731
      })
  } catch (error) {
    console.error('kaxaa: index price catch:', error)
  }
  // 0 USD
  return 0.3731
}

export default {
  getKaxaaIndexPrice,
}
